<template>
  <div class="Honor">
    <!-- 企业资质 -->
    <div class="box-qualification wow fadeInUp animated">
      <RecruitTit cn="企业资质" en="ENTERPRISE QUALIFICATION"></RecruitTit>
      <div class="b_cont" >
        <carousel-3d
          class="carousel-3d"
          :autoplay="true"
          :width="350"
          :height="526"
          :display="7"
          :controlsVisible="true"
          v-if="qualificationImgList.length>0"
        >
          <slide
            v-for="(item, index) in qualificationImgList"
            :key="index"
            :index="index"
          >
            <img
              :data-index="index"
              :large="item.imageUrl"
              preview="qualification"
              :preview-text="item.imageName"
              :src="item.imageUrl"
            />
          </slide>
        </carousel-3d>
      </div>
    </div>
    <!-- 企业荣誉 -->
    <div class="box-honor wow fadeInUp animated">
      <RecruitTit cn="企业荣誉" en="ENTERPRISE HONOR"></RecruitTit>
      <div class="b_cont">
        <swiperCpt
          class="wow fadeInUp animated"
          ref="honorImgSwiper"
          :delay="5000"
          :loop="honorImgList.length>3"
          :autoplay="honorImgList.length>3"
          sid="honorImgSwiper"
          :slidesPerView="3"
          v-if="honorImgList.length>0"
        >
          <div
            class="swiper-slide"
            v-for="(item, index) in honorImgList"
            :key="index"
          >
            <div class="honorImg">
              <img
                :src="item.imageUrl"
                :large="item.imageUrl"
                preview="honor"
                :preview-text="item.imageName"
                :alt="'honorImg' + index"
              />
            </div>
          </div>
        </swiperCpt>
        <div
          v-if="honorImgList.length>3"
          class="swiperBtn swiperBtn_left"
          @click="$refs.honorImgSwiper.swiperSl.swipePrev()"
        ></div>
        <div
          v-if="honorImgList.length>3"
          class="swiperBtn swiperBtn_right"
          @click="$refs.honorImgSwiper.swiperSl.swipeNext()"
        ></div>
      </div>
    </div>
    <div class="decoration decoration2"></div>
  </div>
</template>

<script>
import { Carousel3d, Slide } from "vue-carousel-3d";
import swiperCpt from "@/components/common/swiperCpt.vue";
import RecruitTit from "../../components/common/recruitTit";
if (process.browser) {
  var { WOW } = require("wowjs");
}
export default {
  name:'Honor',
  data() {
    return {
      qualificationImgList: [], // 资质图片
      qualificationImgTotal:100000,// 资质图片数量
      honorImgList: [], // 荣耀图片
      honorImgTotal:100000,// 荣耀图片数量
      // qualificationImgList: [
      //   {
      //     imageUrl: require("../../assets/images/company/Honor/qualification2.png"),
      //     imgBigsrc:require("../../assets/images/company/Honor/qualification2.png"),
      //     imageName: "环境管理体系认证（英文）",
      //   },
      //   {
      //     imageUrl: require("../../assets/images/company/Honor/qualification3.png"),
      //     imgBigsrc: require("../../assets/images/company/Honor/qualification3.png"),
      //     imageName: "环境管理体系认证证书（英文副本）",
      //   },
      //   {
      //     imageUrl: require("../../assets/images/company/Honor/qualification4.png"),
      //     imgBigsrc: require("../../assets/images/company/Honor/qualification4.png"),
      //     imageName: "环境管理体系认证证书（英文正本）",
      //   },
      //   {
      //     imageUrl: require("../../assets/images/company/Honor/qualification5.png"),
      //     imgBigsrc: require("../../assets/images/company/Honor/qualification5.png"),
      //     imageName: "环境管理体系认证证书（中文副本）",
      //   },
      //   {
      //     imageUrl: require("../../assets/images/company/Honor/qualification6.png"),
      //     imgBigsrc: require("../../assets/images/company/Honor/qualification6.png"),
      //     imageName: "环境管理体系认证证书（中文正本）",
      //   },
      //   {
      //     imageUrl: require("../../assets/images/company/Honor/qualification7.png"),
      //     imgBigsrc: require("../../assets/images/company/Honor/qualification7.png"),
      //     imageName: "危险化学品登记证",
      //   },
      //   {
      //     imageUrl: require("../../assets/images/company/Honor/qualification8.png"),
      //     imgBigsrc: require("../../assets/images/company/Honor/qualification8.png"),
      //     imageName: "知识产权管理体系认证证书",
      //   },
      //   {
      //     imageUrl: require("../../assets/images/company/Honor/qualification9.png"),
      //     imgBigsrc: require("../../assets/images/company/Honor/qualification9.png"),
      //     imageName: "质量管理体系认证证书英文",
      //   },
      //   {
      //     imageUrl: require("../../assets/images/company/Honor/qualification10.png"),
      //     imgBigsrc: require("../../assets/images/company/Honor/qualification10.png"),
      //     imageName: "质量管理体系认证证书英文副本",
      //   },
      //   {
      //     imageUrl: require("../../assets/images/company/Honor/qualification11.png"),
      //     imgBigsrc: require("../../assets/images/company/Honor/qualification11.png"),
      //     imageName: "质量管理体系认证证书英文正本",
      //   },
      //   {
      //     imageUrl: require("../../assets/images/company/Honor/qualification12.png"),
      //     imgBigsrc: require("../../assets/images/company/Honor/qualification12.png"),
      //     imageName: "质量管理体系认证证书中文副本",
      //   },
      //   {
      //     imageUrl: require("../../assets/images/company/Honor/qualification13.png"),
      //     imgBigsrc: require("../../assets/images/company/Honor/qualification13.png"),
      //     imageName: "质量管理体系认证证书中文正本",
      //   },
      //   {
      //     imageUrl: require("../../assets/images/company/Honor/qualification1.png"),
      //     imgBigsrc:require("../../assets/images/company/Honor/qualification1_1.png"),
      //     imageName: "安全生产许可证（副本20210420）",
      //   },
      //   {
      //     imageUrl: require("../../assets/images/company/Honor/qualification14.png"),
      //     imgBigsrc:require("../../assets/images/company/Honor/qualification14.png"),
      //     imageName: "安全生产许可证（副本20210420）",
      //   },
      // ],
      // honorImgList: [
      //   {
      //     imageUrl: require("../../assets/images/company/Honor/Honor1.png"),
      //     imageName: "2016-2017安康杯优秀单位",
      //   },
      //   {
      //     imageUrl: require("../../assets/images/company/Honor/Honor2.png"),
      //     imageName: "2017年度出口先进企业",
      //   },
      //   {
      //     imageUrl: require("../../assets/images/company/Honor/Honor3.png"),
      //     imageName: "2017年度守合同重信用企业",
      //   },
      //   {
      //     imageUrl: require("../../assets/images/company/Honor/Honor4.png"),
      //     imageName: "2018扩度纳税增长优秀企业",
      //   },
      //   {
      //     imageUrl: require("../../assets/images/company/Honor/Honor5.png"),
      //     imageName: "2018年度出口先进企业",
      //   },
      //   // {
      //   //   imageUrl: require("../../assets/images/company/Honor/Honor6.png"),
      //   //   imageName: "2019年广州市总工会“中国梦·劳动美”职工网络文艺晚会优秀奖",
      //   // },
      //   // {
      //   //   imageUrl: require("../../assets/images/company/Honor/Honor7.png"),
      //   //   imageName: "2019年广州万力集团先进基层党组织",
      //   // },
      //   {
      //     imageUrl: require("../../assets/images/company/Honor/Honor8.png"),
      //     imageName: "高新技术企业",
      //   },
      //   {
      //     imageUrl: require("../../assets/images/company/Honor/Honor9.png"),
      //     imageName: "工匠杯优秀组织奖",
      //   },
      //   {
      //     imageUrl: require("../../assets/images/company/Honor/Honor10.png"),
      //     imageName: "投资企业协会副会长",
      //   },
      //   {
      //     imageUrl: require("../../assets/images/company/Honor/Honor11.png"),
      //     imageName: "万力集团五四红旗团（总）支部",
      //   },
      //   // {
      //   //   imageUrl: require("../../assets/images/company/Honor/Honor12.png"),
      //   //   imageName: "危险化学品标准化三级企业",
      //   // },
      //   {
      //     imageUrl: require("../../assets/images/company/Honor/Honor13.png"),
      //     imageName: "政校企协同育人基地",
      //   },
      //   {
      //     imageUrl: require("../../assets/images/company/Honor/Honor14.png"),
      //     imageName: "重点龙头企业牌匾（2019年12月获得）",
      //   },
      //   {
      //     imageUrl: require("../../assets/images/company/Honor/Honor15.png"),
      //     imageName: "自治区级林业产业重点龙头企业",
      //   },
      //   {
      //     imageUrl: require("../../assets/images/company/Honor/Honor16.png"),
      //     imageName: "慈善捐赠先进单位",
      //   },
      // ],
    };
  },
  mounted() {
    if (process.browser) {
      new WOW({
        live: false,
        offset: 0,
      }).init();
    }
    this.getHonorImgList();
    this.getQualification();
  },
  methods: {
    // 获取荣耀图片
    async getHonorImgList() {
      let res = await this.$request.getImageManageList({
        columnType: 8,
        pageSize:this.honorImgTotal
      });
      // 获取接口有多少条数据
      if(this.honorImgTotal ==''){
        this.honorImgTotal = res.total;
        this.getHonorImgList();
        return;
      }
      // 图片增加相关域名
      res.rows.map((val, index) => {
        val.imageUrl = this.$store.state.baseUrl + val.imageUrl ;
      });
      this.honorImgList = res.rows;
    },
    // 获取资质图片
    async getQualification() {
      let res = await this.$request.getImageManageList({
        columnType: 7,
        pageSize:this.qualificationImgTotal
      });
      // console.log(res.rows);
      // 图片增加相关域名
      res.rows.map((val, index) => {
        val.imageUrl = this.$store.state.baseUrl + val.imageUrl ;
      });
      this.qualificationImgList = res.rows;
    },
  },
  components: {
    RecruitTit,
    swiperCpt,
    Carousel3d,
    Slide,
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/common.scss";
.Honor {
  position: relative;
  padding: 3.13vw 0;
  .decoration2 {
    display: block;
    width: 5.21vw;
    height: 5.21vw;
    border-radius: 50%;
    border: 3.13vw solid $ThemeColor;
    position: absolute;
    right: 4.17vw;
    top: 2.81vw;
    z-index: -1;
  }
  .box-qualification {
    position: relative;
    .b_cont {
      // margin: 1.56vw 0 0 0;
      // padding: 3.13vw 0 0 0;
      // height: 34.9vw - 3.13vw;
      margin: 30px 0 0 0;
      padding: 60px 0 0 0;
      height: 670px - 60px;
      height: 670px - 60px;
      background: url("../../assets/images/company/Honor/qualificationBg.png")
        top center no-repeat;
      // background-size: 100%;
      .carousel-3d {
        img {
          display: block;
          width: 100%;
        }
        /deep/ .carousel-3d-slide{
            background-color: transparent;
            border: none;
          }
      }
    }
  }
  .box-honor {
    width: $contWidth;
    margin: 0 auto;
    position: relative;
    padding: 2.08vw 0 0 0;
    .b_cont {
      margin: 1.56vw 0 0 0;
      height: 15.63vw;
      position: relative;
      .honorImg {
        width: 21.77vw;
        height: 14.22vw;
        margin: 0 3.23vw 0 0;
        &:nth-child(3n) {
          margin: 0;
        }
        img {
          display: block;
          width: 100%;
        }
      }
      .swiperBtn {
        width: 2.5vw;
        height: 2.5vw;
        cursor: pointer;
        position: absolute;
        top: 50%;
        margin-top: -1.25vw;
        z-index: 66;
        &.swiperBtn_left {
          left: 0;
          background: url("../../assets/images/common/swiperBtn_left.png");
          background-size: cover;
        }
        &.swiperBtn_right {
          right: 2.5vw;
          background: url("../../assets/images/common/swiperBtn_right.png");
          background-size: cover;
        }
      }
    }
  }
}
@media (min-width: 1920px) {
  .Honor {
    position: relative;
    padding: 60px 0;
    .decoration2 {
      display: block;
      width: 100px;
      height: 100px;
      border-radius: 50%;
      border: 60px solid $ThemeColor;
      position: absolute;
      right: 80px;
      top: 54px;
      z-index: -1;
    }
    .box-qualification {
      position: relative;
      .b_cont {
        margin: 30px 0 0 0;
        padding: 60px 0 0 0;
        height: 670px - 60px;
        background: url("../../assets/images/company/Honor/qualificationBg.png")
          top center no-repeat;
          background-size: cover;
        .carousel-3d {
          img {
            display: block;
          }
          /deep/ .carousel-3d-slide{
            background-color: transparent;
            border: none;
          }
        }
      }
    }
    .box-honor {
      width: 1400px;
      margin: 0 auto;
      position: relative;
      padding: 40px 0 0 0;
      .b_cont {
        margin: 30px 0 0 0;
        height: 300px;
        position: relative;
        .honorImg {
          width: 418px;
          height: 273px;
          margin: 0 60px 0 2px;
          &:nth-child(3n) {
            margin: 0;
          }
        }
        .swiperBtn {
          width: 48px;
          height: 48px;
          cursor: pointer;
          position: absolute;
          top: 50%;
          margin-top: -24px;
          z-index: 66;
          &.swiperBtn_left {
            left: 0;
            background: url("../../assets/images/common/swiperBtn_left.png");
            background-size: cover;
          }
          &.swiperBtn_right {
            right: 48px;
            background: url("../../assets/images/common/swiperBtn_right.png");
            background-size: cover;
          }
        }
      }
    }
  }
}
</style>